<template>
  <div class="modal modal-outer" @click="isOpen = false" v-if="isOpen">
    <div class="modal-content">
      <div class="modal-card">
        Выберите и нажмите <br />
        на понравившуюся <br />
        мандаринку
      </div>

      <img
        class="modal-arrow"
        src="@/assets/img/mandarin-prediction/modal-arrow.svg"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PredictionModal',
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    open() {
      this.isOpen = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mandarin-prediction/_fonts.scss';

.modal-outer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  z-index: 110;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
}

.modal-card {
  font-family: 'M Plus Rounded 1c', sans-serif;
  margin-top: 21vh;
  font-size: 40px;
  line-height: 55px;
  color: white;
  padding: 27px 55px;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: inset 0px -15.0395px 15.0395px rgba(255, 255, 255, 0.15),
    inset 0px 60.1581px 91.1487px rgba(255, 255, 255, 0.2),
    inset 0px -36.4595px 50px rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(45px);
  border-radius: 40px;
}

.modal-arrow {
  margin-top: 9px;
  margin-right: 2vw;
  width: 4.2vw;
  height: auto;
  transform: rotate(-4.74deg);
}

@media (max-width: 768px) {
  .modal-card {
    font-size: 27px;
    border-radius: 21px;
    padding: 19px 37px;
    line-height: 140%;
  }

  .modal-arrow {
    width: 14vw;
  }
}

@media (max-width: 349px) {
  .modal-card {
    font-size: 20px;
    border-radius: 21px;
  }
}
</style>
